import styled from 'styled-components';

export const Suggestions = styled.div`
  margin: 0;
`;

export const Suggestion = styled.div`
  width: 100%;
  padding: 8px 0;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  position: absolute;
  z-index: 2;
`;

export const AddressOption = styled.div`
  margin: 0 38px 16px 16px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: ${({ theme }) => theme.historyProviderColor || '#333333'};
`;

export const LocationContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const LocateMeIcon = styled.div`
  width: 18px;
  height: 18px;
  margin: 2px 7px 3px 16px;
`;

export const LocateMeOption = styled.div`
  width: 247px;
  height: 20px;
  margin: 0 0 3px 7px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${({ theme }) => theme.mediumGray || '#999999'};
`;
